import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import type { ComponentPropsWithoutRef } from "react";

import { useIsCircleV4FeatureEnabled } from "@/react/hooks/useIsCircleV4FeatureEnabled";

import { ModerationInfoModalComponent } from "./ModerationInfoModalComponent";
import { ModerationInfoModalUIKitComponent } from "./ModerationInfoModalUIKitComponent";

type ModerationInfoModalUIKitComponentProps = ComponentPropsWithoutRef<
  typeof ModerationInfoModalUIKitComponent
>;

const ModerationInfoModalUIKit = ModalManager.create(
  (props: ModerationInfoModalUIKitComponentProps) => (
    <ModerationInfoModalUIKitComponent {...props} />
  ),
);

type ModerationInfoModalComponentProps = Omit<
  ComponentPropsWithoutRef<typeof ModerationInfoModalComponent>,
  "open" | "onOpenChange"
>;

const ModerationInfoModal = ModalManager.create(
  (props: ModerationInfoModalComponentProps) => {
    const modal = useModal();

    return (
      <ModerationInfoModalComponent
        {...props}
        open={modal.visible}
        onOpenChange={(nextOpen: boolean) => {
          if (!nextOpen) {
            void modal.hide();
          }
        }}
      />
    );
  },
);

export const useModerationInfoModal = () => {
  const isCircleV4 = useIsCircleV4FeatureEnabled("circle_v4_modals_enabled");
  const ModalComponent = isCircleV4
    ? ModerationInfoModal
    : ModerationInfoModalUIKit;

  return useModal(ModalComponent);
};
